import "../../App.css";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

export default function DoctorSidebar() {
  const navigate = useNavigate();
  const [showTransaction, setShowTransaction] = useState(
    localStorage.getItem("doctorShowTransaction") === "1"
  );

  useEffect(() => {
    fetch(window.API_PREFIX + "admin/doctordetail", {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        Token: localStorage.getItem("DToken"),
      }),
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data?.status === "Block") {
          toast.error(data?.message || "Unauthorized");
          localStorage.clear();
          navigate("/doctor");
          window.location.reload();
          return;
        }
        if (data?.status === "1") {
          const enabled = Number(data?.data?.ShowTransaction || 0) === 1;
          setShowTransaction(enabled);
          localStorage.setItem("doctorShowTransaction", enabled ? "1" : "0");
        }
      });
  }, [navigate]);

  const link = (path, label, icon) => (
    <div
      className={
        window.location.pathname.includes(path)
          ? "sidebar_dashboard_title_division_active"
          : "sidebar_dashboard_title_division"
      }
      onClick={() => navigate(path)}
    >
      <i className={icon + " me-2"}></i>
      {label}
    </div>
  );

  return (
    <div className="sidebar_main_division">
      {link("/doctor/dashboard", "Dashboard", "fa-solid fa-shapes")}
      {link("/doctor/appointment-by-date", "Appointment By Date", "fa-solid fa-calendar-days")}
      {link("/doctor/schedule-timing", "Schedule Timing", "fa-solid fa-calendar-day")}
      {showTransaction
        ? link(
            "/doctor/transactions",
            "Transactions",
            "fa-solid fa-indian-rupee-sign"
          )
        : null}
      {link("/doctor/profile-setting", "Profile Settings", "fa-solid fa-user-pen")}
      {link("/doctor/change-password", "Change Password", "fa-solid fa-key")}
      <div
        className="sidebar_dashboard_title_division"
        onClick={() => {
          localStorage.clear();
          navigate("/doctor");
          window.location.reload();
        }}
      >
        <i className="fa-solid fa-right-from-bracket me-2"></i>
        Logout
      </div>
    </div>
  );
}

